import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import NxButton, {NxButtonProps} from '../nxButton/NxButton';

export type NxButtonLinkProps = Omit<NxButtonProps, 'onClick'> & { to: string };

const NxButtonLink = ({children, ...rest }: NxButtonLinkProps): ReactElement => {

  const history = useHistory();

  return (
    <NxButton {...rest} onClick={(): void => history.push(rest.to)}>
      {children}
    </NxButton>
  );
};

export default NxButtonLink;